import { Component, computed, inject, input } from '@angular/core';

import { localStorageSignal } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { HrAssistantService } from '@core/intelligence-smart-ui';
import {
  ButtonComponent,
  HeadingComponent,
  IconButtonComponent,
} from '@core/user-interface-legacy';

import { chatImage } from './chat-image';

@Component({
  selector: 'ask-hr-setup-banner',
  template: `
    @if (isVisible()) {
      <div layout layout-vertical layout-space-between layout-align-items-start>
        <rt-heading variant="heading large">
          <span class="text-on-primary">
            {{ 'tlc.ask_hr.forms.banner.title' | translate }}
          </span>
        </rt-heading>
        <rt-button variant="secondary" (click)="onSetUp()">
          {{ 'tlc.ask_hr.forms.banner.set_up_now' | translate }}
        </rt-button>
      </div>
      @if (canClose()) {
        <rt-icon-button
          iconName="close"
          variant="plain-ghost"
          size="small"
          (click)="isClosed.set(true)"
          margin-left-auto
        />
      }
      <img [src]="chatImage" alt="Chat Illustration" class="chat-image" />
    }
  `,
  imports: [HeadingComponent, ButtonComponent, IconButtonComponent, TranslatePipe],
  styleUrl: 'setup-banner.component.less',
  host: {
    '[style.display]': 'isVisible() ? null : "none"',
  },
})
export class SetupBannerComponent {
  private readonly hrAssistantService = inject(HrAssistantService);
  protected readonly chatImage = chatImage;

  public canClose = input(true);

  protected isVisible = computed(() => {
    if (this.hrAssistantService.assistantConfig()?.ask) return false;
    if (this.canClose()) return !this.isClosed();

    return true;
  });

  protected isClosed = localStorageSignal('ask-hr-assistant-banner-setup', false);

  protected onSetUp() {
    this.hrAssistantService.redirectToIntelligenceSettings();
  }
}
